import React from "react";
import { Badge } from "@fluentui/react-components";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

export const NewBadge: React.FunctionComponent = () => {
  return (
    <Badge
      shape="rounded"
      appearance="filled"
      style={{
        borderStyle: "hidden !important",
        backgroundColor: "rgb(234, 143, 0)",
        borderColor: "rgb(234, 143, 0)",
        borderRadius: "2px",
        margin: "0px 5px",
        minWidth: "fit-content",
        color: "white",
        padding: "0px 2px",
        fontSize: "0.750rem",
      }}
    >
      {formatMessage("cof.base.new")}
    </Badge>
  );
};
